export interface WorkflowResponseState {
  questionId: string;
  exceptionCount?: number;
  status?: string;
  count?: number;
  uom?: string;
  workspaceRoutineId?: string;
}

export interface AuditLog {
  questionId: string;
  changes: Record<string, { oldValue: any; newValue: any }>;
}
export interface WorkflowAuditLog {
  auditLog: AuditLog[];
  userId: string;
}
